package com.ijoin.i18n

/**
 * Arabic strings implementation
 */
object ArabicStrings : Strings {
    override val appName = "iJoin"
    override val clickMe = "!انقر هنا"
    override val greetingMessage = "Compose"
    override fun helloPlatform(platformName: String) = "!مرحباً، $platformName"
    override val language = "اللغة"
    override val english = "الإنجليزية"
    override val russian = "الروسية"
    override val changeLanguage = "تغيير اللغة"
    override val ok = "موافق"
    override val cancel = "إلغاء"
    override val save = "حفظ"
    override val delete = "حذف"
    override val edit = "تعديل"
    override val close = "إغلاق"
    override val retry = "إعادة المحاولة"
    override val share = "مشاركة"
    override val unknownErrorMessage = "حدث خطأ ما. يرجى المحاولة مرة أخرى."
    override val missingEventDateError = "تاريخ الحدث مفقود."
    override val slotSelectionRequired = "اختر موعداً واحداً على الأقل."
    override val userContextMissingError = "تعذر التعرف على المستخدم الحالي."
    override val cancelSlotsSelectionRequired = "اختر موعداً واحداً على الأقل للإلغاء."
    override val cancelDaySelectionRequired = "اختر يوماً للإلغاء."
    override val restoreSlotsSelectionRequired = "اختر موعداً واحداً على الأقل للاستعادة."
    override val restoreDaySelectionRequired = "اختر يوماً للاستعادة."
    override val cancelSlotsFailed = "تعذر إلغاء المواعيد المحددة."
    override val cancelDayFailed = "تعذر إلغاء اليوم المحدد."
    override val restoreSlotsFailed = "تعذر استعادة المواعيد المحددة."
    override val restoreDayFailed = "تعذر استعادة اليوم المحدد."
    override val cancelEventFailed = "تعذر إلغاء الحدث."
    override val restoreEventFailed = "تعذر استعادة الحدث."
    override val selectedDateUnavailableError = "التاريخ المحدد غير متاح."
    override val selectedDateInPastError = "التاريخ المحدد قد مضى."
    override val notSelected = "غير محدد"
    override fun atTime(time: String) = "الساعة $time"
    override val enableNotificationsTitle = "ابق على اطلاع"
    override val enableNotificationsBody = "فعّل إشعارات المتصفح للحصول على تحديثات حول الأحداث الجديدة ونشاط الدردشة."
    override val allowNotificationsAction = "السماح بالإشعارات"
    override val notNowAction = "ليس الآن"
    override val searchPlaceholder = "البحث عن أحداث، منظمين، أماكن..."
    override val myTickets = "تذاكري"
    override val tapToViewTicket = "انقر لعرض التذكرة"
    override val favoriteEvents = "المفضلة"
    override val eventsYouSaved = "الأحداث التي حفظتها"
    override val recommendedForYou = "موصى به لك"
    override val curatedEvents = "أحداث مختارة بناءً على اهتماماتك"
    override val recommendations = "التوصيات"
    override val upcomingEvents = "الأحداث القادمة"
    override val searchResults = "نتائج البحث"
    override val noResults = "لم يتم العثور على نتائج"
    override val noAvailableEvents = "لا توجد أحداث متاحة"
    override val createEvent = "إنشاء حدث"
    override val menu = "القائمة"
    override val home = "الرئيسية"
    override val explore = "استكشاف"
    override val tickets = "التذاكر"
    override val profile = "الملف الشخصي"
    override val upcomingPaidTicketsTitle = "التذاكر المدفوعة القادمة"
    override val otherTicketsTitle = "تذاكر أخرى"
    override val offlineTicketsNotice = "عرض التذاكر المحفوظة. قد تكون بعض المعلومات قديمة."
    override val ticketsEmptyMessage = "ليس لديك تذاكر بعد."
    override val ticketDetailsTitle = "تفاصيل التذكرة"
    override val ticketNumberLabel = "رقم التذكرة"
    override val ticketStatusActive = "نشطة"
    override val ticketStatusCancelled = "ملغاة"
    override val ticketStatusRefunded = "مستردة"
    override val ticketStatusUsed = "مستخدمة"
    override val ticketHolderLabel = "حامل التذكرة"
    override val cancelTicketAction = "إلغاء التذكرة"
    override val ticketCancellationConfirmTitle = "إلغاء التذكرة؟"
    override val ticketCancellationConfirmMessage = "سيؤدي هذا إلى تحرير مقعدك لحضور آخر."
    override val ticketCancellationSuccess = "تم إلغاء التذكرة"
    override val ticketCancellationFailure = "تعذر إلغاء التذكرة"
    override val ticketLoadError = "تعذر تحميل التذكرة"
    override val refresh = "تحديث"
    override val settings = "الإعدادات"
    override val createEventTitle = "إنشاء حدث"
    override val eventTitle = "عنوان الحدث"
    override val eventTitlePlaceholder = "أدخل اسم الحدث"
    override val eventDescription = "الوصف"
    override val eventDescriptionPlaceholder = "صف حدثك..."
    override val aiGenerateDescription = "الذكاء الاصطناعي: إنشاء وصف"
    override val aiFormatDescription = "الذكاء الاصطناعي: تنظيم الوصف وإنهاؤه"
    override val addMedia = "إضافة صورة/فيديو"
    override val mediaChooseFile = "اختر ملفاً"
    override val location = "الموقع"
    override val onlineEvent = "حدث عبر الإنترنت"
    override val onlineLink = "رابط عبر الإنترنت"
    override val onlineLinkPlaceholder = "https://example.com/meeting"
    override val onlineLinkNotice = "سيكون الرابط متاحاً بعد الدفع"
    override val placeName = "اسم المكان"
    override val address = "العنوان"
    override val ticketPrice = "سعر التذكرة"
    override val ticketPricePlaceholder = "25.00"
    override val dateAndTime = "التاريخ والوقت"
    override val recurringEvent = "حدث متكرر"
    override val recurrenceType = "نوع التكرار"
    override val daysOfWeek = "أيام الأسبوع"
    override val daysOfMonth = "أيام الشهر"
    override val selectDaysOfWeek = "اختر أيام الأسبوع"
    override val selectDaysOfMonth = "اختر أيام الشهر"
    override val time = "الوقت (سس:دد)"
    override val hiddenInfo = "معلومات مخفية"
    override val hiddenInfoDescription = "ستكون متاحة للمستخدمين بعد شراء التذكرة"
    override val hiddenInfoPlaceholder = "معلومات مرئية فقط بعد الدفع..."
    override val enableGroupChatLabel = "إنشاء دردشة جماعية"
    override val enableGroupChatDescription = "كل من يحجز أو يشتري تذكرة ينضم إلى دردشة مشتركة."
    override val groupChatLabel = "دردشة جماعية"
    override val groupChatSubtitle = "دردشة لجميع المشاركين"
    override val carpoolSettings = "إعدادات مشاركة السيارة"
    override val enableCarpool = "تفعيل مشاركة السيارة"
    override val contactInfoSettings = "إعدادات معلومات الاتصال"
    override val requireContactInfo = "جمع معلومات الاتصال"
    override val requireContactInfoDescription = "مطالبة العملاء بتقديم الهاتف ومعلومات إضافية عند الحجز"
    override val freeCarpool = "مشاركة سيارة مجانية"
    override val carpoolPaymentPerPerson = "الدفع لكل راكب"
    override fun carpoolPaymentLabel(symbol: String) = "الدفع لكل شخص ($symbol)"
    override val carpoolPaymentPlaceholder = "10.00"
    override val carpoolDescription = "يمكن للمستخدمين الإشارة إلى أن لديهم سيارة وتحديد عدد الركاب الذين يمكنهم نقلهم"
    override val carpoolPaymentHint = "حدد كم يجب أن يدفع الركاب للرحلة"
    override val selectDate = "اختر التاريخ"
    override val back = "رجوع"
    override val create = "إنشاء"
    override val currency = "العملة"
    override val selectCurrency = "اختر العملة"
    override val category = "الفئة"
    override val selectCategory = "اختر الفئة"
    override val tags = "الوسوم"
    override val addTag = "إضافة وسم"
    override val maxCapacity = "السعة القصوى"
    override val maxCapacityPlaceholder = "50"
    override val duration = "المدة"
    override val durationMinutes = "المدة (دقائق)"
    override fun formatDuration(minutes: Int): String {
        if (minutes <= 0) return ""
        val days = minutes / (24 * 60)
        val hours = (minutes % (24 * 60)) / 60
        val mins = minutes % 60

        return when {
            days >= 7 -> {
                val weeks = days / 7
                val remainingDays = days % 7
                if (remainingDays > 0) "$weeks أسبوع $remainingDays يوم"
                else "$weeks أسبوع"
            }
            days > 0 -> {
                if (hours > 0) "$days يوم $hours ساعة"
                else "$days يوم"
            }
            hours > 0 -> {
                if (mins > 0) "$hours ساعة $mins دقيقة"
                else "$hours ساعة"
            }
            else -> "$mins دقيقة"
        }
    }
    override val locationCountry = "البلد"
    override val selectOnMap = "اختر على الخريطة"
    override val locationSearchPlaceholder = "أدخل العنوان أو اسم المكان"
    override val onlineLinkHidden = "سيكون الرابط مرئياً فقط بعد الدفع"
    override val timeZone = "المنطقة الزمنية"
    override fun timeZoneValue(timeZoneId: String) = "المنطقة الزمنية: $timeZoneId"
    override val selectTimeZone = "اختر المنطقة الزمنية"
    override val localTimeZone = "المنطقة الزمنية المحلية"
    override val mediaFilesAdded = "تمت إضافة الملفات"
    override val free = "مجاني"
    override val priceForFreeEvent = "0 - للحدث المجاني"
    override val additionalOptions = "خيارات إضافية"
    override val ageRestriction = "قيود العمر"
    override val languageEvent = "لغة الحدث"
    override val contactInfo = "معلومات الاتصال"
    override val website = "الموقع الإلكتروني"
    override val phone = "الهاتف"
    override val email = "البريد الإلكتروني"
    override val comment = "تعليق"
    override val phoneRequired = "الهاتف مطلوب"
    override val city = "المدينة"
    override val search = "بحث"
    override val year = "السنة"
    override val month = "الشهر"
    override val day = "اليوم"
    override fun weekdayShortName(index: Int) = listOf("إثن", "ثلا", "أرب", "خمي", "جمع", "سبت", "أحد")[index % 7]
    override fun weekdayName(index: Int) = listOf("الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد")[index % 7]
    override fun monthNameFull(month: Int) = listOf(
        "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
        "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
    )[(month - 1).mod(12)]
    override fun monthNameGenitive(month: Int) = monthNameFull(month)
    override val createEventWizard = "إنشاء حدث"
    override val step = "الخطوة"
    override val of = "من"
    override val next = "التالي"
    override val previous = "السابق"
    override val saveDraft = "حفظ المسودة"
    override val editEvent = "تعديل الحدث"
    override val step1BasicInfo = "المعلومات الأساسية"
    override val step2Schedule = "الجدول الزمني"
    override val scheduleTypeLabel = "نوع الجدول"
    override val scheduleOneTimeDescription = "حدث واحد في تاريخ محدد"
    override val scheduleWeeklyDescription = "يتكرر في الأيام المحددة"
    override val scheduleSlotDescription = "تقويم المواعيد القابلة للحجز"
    override val scheduleOneTimeSetup = "إعداد حدث واحد"
    override val schedulePreviewTitle = "معاينة"
    override fun schedulePreviewDate(date: String) = "التاريخ: $date"
    override fun schedulePreviewTime(start: String, end: String) = "الوقت: $start - $end"
    override val step3Location = "الموقع"
    override val eventSetupTitle = "إعداد الحدث"
    override val eventTypeLabel = "نوع الحدث"
    override val oneTimeEvent = "حدث واحد"
    override val eventSeries = "سلسلة أحداث"
    override val weekly = "أسبوعي"
    override val monthly = "شهري"
    override val slotBooking = "حجز الموعد"
    override val slotLabel = "موعد"
    override val slotsLabel = "مواعيد"
    override val selectDayOfWeek = "اختر يوم الأسبوع"
    override val selectDayOfMonth = "اختر يوم الشهر"
    override val availableTimeRange = "نطاق الوقت المتاح"
    override val startTime = "وقت البدء"
    override val endTime = "وقت الانتهاء"
    override val endDateLabel = "تاريخ الانتهاء (اختياري)"
    override val invalidEndDate = "يجب أن يكون تاريخ الانتهاء في نفس تاريخ البدء أو بعده"
    override val invalidEndTime = "يجب أن يكون وقت الانتهاء بعد وقت البدء"
    override val eventDateMustBeFuture = "يجب أن يكون تاريخ الحدث في المستقبل"
    override val eventTimeMustBeFuture = "يجب أن يكون وقت الحدث بعد الوقت الحالي"
    override val slotSettings = "إعدادات الموعد"
    override val minSlots = "الحد الأدنى للمواعيد"
    override val minSlotsPlaceholder = "1"
    override val slotDuration = "المدة (دقائق)"
    override val slotDurationPlaceholder = "30"
    override val perDayTimeConfiguration = "الساعات المتاحة لكل يوم"
    override val driverCompensation = "تعويض السائق"
    override val fixedAmountPerPassenger = "مبلغ ثابت لكل راكب"
    override val coordinateRide = "تنسيق الرحلة"
    override val participantsWithCar = "المشاركون بسيارة"
    override val needRide = "بحاجة لتوصيلة"
    override val draft = "مسودة"
    override val saved = "تم الحفظ"
    override val eventSaveErrorTitle = "تعذر حفظ الحدث"
    override val eventSaveErrorMessage = "حدث خطأ أثناء حفظ الحدث. يرجى المحاولة مرة أخرى."
    override val deleteEventTitle = "حذف الحدث؟"
    override val deleteEventMessage = "لا يمكن التراجع عن هذا الإجراء. هل تريد المتابعة؟"
    override val eventDeletedMessage = "تم حذف الحدث"
    override val organizerLabel = "المنظم"
    override val online = "عبر الإنترنت"
    override val offline = "حضوري"
    override val eventDetailsTitle = "تفاصيل الحدث"
    override val addToFavorites = "إضافة للمفضلة"
    override val removeFromFavorites = "إزالة من المفضلة"
    override val ticketTierStandard = "قياسي"
    override fun ticketsAvailable(count: Int) = "$count تذكرة متاحة"
    override val viewTicket = "عرض التذكرة"
    override val bookingRequestFailed = "فشل حجز التذكرة"
    override val contactSendFailed = "فشل إرسال معلومات الاتصال"
    override val unexpectedReservation = "حجز غير متوقع لحدث مجاني"
    override val sampleReviewerName = "أحمد محمد"
    override val sampleReviewTimeAgo = "منذ يومين"
    override val selectVisitDate = "اختر تاريخ الزيارة"
    override fun availableDaysLabel(days: String) = "الأيام المتاحة: $days"
    override val previousMonth = "الشهر السابق"
    override val nextMonth = "الشهر التالي"
    override fun slotSelectionMessage(date: String, time: String?) =
        if (time.isNullOrBlank()) "اخترت: $date" else "اخترت: $date الساعة $time"
    override fun eventImageContentDescription(title: String, index: Int) = "$title - الصورة $index"
    override val dateTbd = "سيتم تحديده"
    override val recurringWeeklyDescription = "يقام هذا الحدث كل أسبوع في الأيام المحددة."
    override val recurringMonthlyDescription = "يقام هذا الحدث كل شهر في الأيام المحددة."
    override val userCardTitle = "ملف المنظم"
    override val followAction = "متابعة"
    override val followingAction = "متابَع"
    override val followersCountLabel = "المتابعون"
    override val followingCountLabel = "المتابَعون"
    override val eventsCountLabel = "الأحداث"
    override val organizerEventsTitle = "الأحداث القادمة"
    override val archiveSectionTitle = "الأرشيف"
    override val aboutOrganizerTitle = "عن المنظم"
    override val userEventsEmpty = "لا يوجد لدى هذا المنظم أحداث قادمة بعد."
    override val userArchiveEmpty = "لا توجد أحداث مؤرشفة."
    override val addShortcutTitle = "إضافة اختصار؟"
    override fun addShortcutMessage(displayName: String) =
        "إضافة $displayName إلى شاشتك الرئيسية للوصول السريع لأحداثهم؟"
    override val addShortcutConfirm = "إضافة اختصار"
    override val addShortcutDismiss = "ليس الآن"
    override val dateLabel = "التاريخ"
    override val participants = "المشاركون"
    override val spotsLeft = "أماكن متبقية"
    override val ticketQuantityLabel = "عدد التذاكر"
    override val increaseQuantity = "زيادة الكمية"
    override val decreaseQuantity = "تقليل الكمية"
    override val costLabel = "تكلفة المشاركة"
    override val serviceFee = "رسوم الخدمة"
    override val totalAmount = "المجموع"
    override fun serviceFeePercent(percent: Int) = "رسوم الخدمة ($percent%)"
    override val dressCode = "قواعد اللباس"
    override val dressCodePlaceholder = "رسمي"
    override val description = "الوصف"
    override val reviews = "التقييمات"
    override val allReviews = "جميع التقييمات"
    override val contactOrganizer = "تواصل مع المنظم"
    override val slotBookingsTitle = "حجوزات المواعيد"
    override val slotBookingsEmptyMessage = "لا توجد مواعيد محجوزة بعد."
    override val showAllBookings = "الكل"
    override val showToday = "اليوم"
    override val showThisMonth = "هذا الشهر"
    override val showSelectedDate = "التاريخ المحدد"
    override val noBookingsForSelectedDate = "لا توجد حجوزات لهذا التاريخ."
    override val noTicketsForSelectedDate = "لا توجد تذاكر لهذا التاريخ."
    override fun totalCount(count: Int) = "المجموع: $count"
    override val cancelEventAction = "إلغاء الحدث"
    override val cancelEventDescription = "إيقاف بيع التذاكر وتحديد الحدث كملغى."
    override val organizerActionsTitle = "أدوات المنظم"
    override val eventAlreadyCancelledNotice = "الحدث ملغى بالفعل."
    override val eventCancelledTitle = "الحدث ملغى"
    override val eventCancelledSubtitle = "ألغى المنظم هذا الحدث. لم يعد الحجز متاحاً."
    override val cancellationReasonLabel = "سبب الإلغاء"
    override val cancellationReasonPlaceholder = "صف سبب الإلغاء"
    override val cancellationReasonRequired = "يرجى تقديم سبب مختصر."
    override val cancelSelectedSlotsAction = "إلغاء المواعيد المحددة"
    override val cancelSelectedSlotsDescription = "لن يتمكن الحاضرون من حجز المواعيد المحددة بعد الآن."
    override val cancelSlotDayAction = "إلغاء اليوم المحدد"
    override val cancelSlotDayDescription = "سيتم حظر جميع المواعيد لليوم المحدد."
    override val selectedSlotsLabel = "المواعيد المحددة"
    override val selectedDayLabel = "اليوم المحدد"
    override val restoreEventAction = "استعادة الحدث"
    override val restoreEventDescription = "إعادة فتح الحدث بعد الإلغاء."
    override val restoreSelectedSlotsAction = "استعادة المواعيد المحددة"
    override val restoreSelectedSlotsDescription = "السماح للحاضرين بحجز المواعيد المحددة مرة أخرى."
    override val restoreSlotDayAction = "استعادة اليوم المحدد"
    override val restoreSlotDayDescription = "إعادة فتح جميع المواعيد لليوم المحدد."
    override val bookingStatusPending = "قيد الانتظار"
    override val bookingStatusConfirmed = "مؤكد"
    override val bookingStatusCancelled = "ملغى"
    override val bookingStatusCompleted = "محجوز"
    override val bookingStatusNoShow = "لم يحضر"
    override val viewDetails = "عرض التفاصيل"
    override val hideDetails = "إخفاء التفاصيل"
    override val openChat = "فتح الدردشة"
    override val clientNotesLabel = "تعليق العميل"
    override val bookingDetailsTitle = "تفاصيل الحجز"
    override val slotBookedByLabel = "محجوز بواسطة"
    override val slotAvailableLabel = "متاح"
    override val statusLabel = "الحالة"
    override val connectTitle = "مدفوعات مباشرة"
    override val connectStatusActive = "نشط"
    override val connectStatusPending = "قيد الانتظار"
    override val connectStatusPlatform = "المنصة"
    override val connectStatusUnderReview = "قيد المراجعة"
    override val connectStatusSetupNeeded = "الإعداد مطلوب"
    override val connectEnableDirectAction = "تفعيل المدفوعات المباشرة"
    override val connectContinueOnboarding = "متابعة الإعداد"
    override val connectOpenDashboard = "فتح لوحة تحكم Stripe"
    override val connectSwitchToPlatform = "التبديل إلى مدفوعات المنصة"
    override val connectPlatformFeeLabel = "رسوم المنصة"
    override val connectDirectPaymentsEnabled = "تم تفعيل المدفوعات المباشرة"
    override val connectSwitchedToPlatform = "تم التبديل إلى مدفوعات المنصة"
    override val connectOnboardingDescription = "قم بإعداد حساب Stripe الخاص بك لاستلام المدفوعات مباشرة"
    override val connectActiveDescription = "تذهب المدفوعات مباشرة إلى حساب Stripe الخاص بك"
    override val connectPlatformDescription = "تتم معالجة المدفوعات عبر المنصة"
    override val connectUnderReviewDescription = "يتم مراجعة حسابك من قبل Stripe"
    override fun connectPlatformFeeValue(percent: Int) = "$percent%"

    override val billingTitle = "الفوترة"
    override val currentBalanceLabel = "الرصيد الحالي"
    override val openBillingAction = "الفوترة والمدفوعات"
    override val withdrawFundsAction = "سحب الأموال"
    override val pendingPayoutsLabel = "المدفوعات المعلقة"
    override val withdrawnTotalLabel = "المسحوب"
    override val billingFilterWeek = "7 أيام"
    override val billingFilterMonth = "30 يوم"
    override val billingFilterQuarter = "90 يوم"
    override val grossSalesLabel = "إجمالي المبيعات"
    override val feesLabel = "الرسوم"
    override val netRevenueLabel = "صافي الإيرادات"
    override val payoutRequestsTitle = "طلبات السحب"
    override val payoutRequestsEmpty = "لا توجد طلبات سحب بعد"
    override val payoutStatusPending = "قيد الانتظار"
    override val payoutStatusProcessing = "قيد المعالجة"
    override val payoutStatusPaid = "مدفوع"
    override val payoutStatusRejected = "مرفوض"
    override val requisitesTitle = "تفاصيل الدفع"
    override val requisitesAccountLabel = "رقم الحساب"
    override val requisitesInnLabel = "INN"
    override val requisitesKppLabel = "KPP"
    override val requisitesBikLabel = "BIC"
    override val bankLabel = "البنك"
    override val soldTicketsTitle = "التذاكر المباعة"
    override val soldTicketsEmpty = "لا توجد مبيعات تذاكر في هذه الفترة"
    override val withdrawConfirmTitle = "سحب الأموال؟"
    override fun withdrawConfirmMessage(amount: String) = "أنت على وشك طلب دفعة بقيمة $amount."
    override val billingWithdrawSuccess = "تم إرسال طلب السحب"
    override val billingWithdrawFailed = "تعذر إرسال طلب السحب"
    override val billingWithdrawUnavailable = "لا يوجد رصيد متاح للسحب"
    override val payoutMethodEtransfer = "eTransfer (كندا)"
    override val payoutMethodWise = "تحويل Wise"
    override val payoutDetailsTitle = "تفاصيل الدفع"
    override val payoutEmailLabel = "بريد المستلم"
    override val payoutWiseNameLabel = "اسم صاحب الحساب"
    override val payoutWiseAccountLabel = "رقم الحساب / IBAN"
    override val payoutWiseBankLabel = "اسم البنك أو SWIFT"
    override val payoutWiseRoutingLabel = "رقم التوجيه"
    override val payoutWiseAccountTypeLabel = "نوع الحساب"
    override val payoutAccountTypeChecking = "جاري"
    override val payoutAccountTypeSavings = "توفير"
    override val payoutNoteLabel = "ملاحظة السحب (اختياري)"
    override fun soldTicketQuantity(quantity: Int, grossAmount: String) = "$quantity x $grossAmount"
    override fun soldTicketBuyerInfo(buyerName: String, soldAt: String) = "$buyerName - $soldAt"
    override fun soldTicketServiceFee(fee: String) = "- $fee"
    override fun shortMonthName(month: Int): String = when (month) {
        1 -> "ينا"; 2 -> "فبر"; 3 -> "مار"; 4 -> "أبر"; 5 -> "ماي"; 6 -> "يون"
        7 -> "يول"; 8 -> "أغس"; 9 -> "سبت"; 10 -> "أكت"; 11 -> "نوف"; 12 -> "ديس"
        else -> ""
    }
    override val accountDetails = "تفاصيل الحساب"
    override val interfaceLanguage = "لغة الواجهة"
    override val profileSavedMessage = "تم تحديث الملف الشخصي"
    override val profileLogoutDescription = "تسجيل الخروج من iJoin على هذا الجهاز."
    override val profileLoadError = "تعذر تحميل الملف الشخصي"
    override val logoutError = "فشل تسجيل الخروج. يرجى المحاولة مرة أخرى."
    override val messagesTitle = "الرسائل"
    override val emptyChatList = "لا توجد محادثات بعد"
    override val emptyMessages = "لا توجد رسائل بعد. ابدأ المحادثة!"
    override val typeMessage = "رسالة..."
    override val send = "إرسال"
    override val chatSearchPlaceholder = "البحث عن مستخدمين بالاسم"
    override val chatSearchNoResults = "لم يتم العثور على مستخدمين"
    override val chatLoadError = "تعذر تحميل رسائل الدردشة"
    override val chatSendError = "تعذر إرسال الرسالة"
    override val chatOpenError = "تعذر فتح الدردشة"
    override val chatStartError = "تعذر بدء الدردشة"
    override val chatSearchError = "تعذر البحث عن مستخدمين الآن"
    override val paymentTitle = "دفع الحجز"
    override val paymentSubtitle = "أكمل دفع حجزك"
    override val paymentDescription = "بمجرد نجاح الدفع، سيتم تحديث حجزك تلقائياً."
    override val paymentPreparing = "جارٍ تحضير دفع Stripe..."
    override val paymentFetchingTickets = "جارٍ جلب تذاكرك..."
    override val paymentCompletedMessage = "تم تأكيد الدفع. إذا لم تظهر التذاكر تلقائياً، قم بتحديث القائمة."
    override val paymentStripePopupHint = "يفتح Stripe في نافذة منبثقة. إذا لم يظهر شيء أو أغلقتها، انقر على \"إعادة بدء الدفع\"."
    override val paymentRetryButton = "إعادة بدء الدفع"
    override val paymentRetryTicketsButton = "جلب التذاكر مرة أخرى"
    override val paymentStartFailed = "فشل بدء الدفع"
    override val paymentTicketContextMissing = "تعذر تحديد الحجز لإصدار التذاكر"
    override val paymentTicketsNotFound = "التذاكر غير موجودة"
    override val paymentTicketsFetchFailed = "تعذر جلب التذاكر"
    override val errorUserNotAuthenticated = "يرجى تسجيل الدخول للمتابعة."
    override val errorAccessDenied = "ليس لديك صلاحية لتنفيذ هذا الإجراء."
    override val errorForbiddenFollowingList = "يمكنك فقط عرض قائمة متابعاتك الخاصة."
    override val errorDataUrlRequired = "بيانات الصورة (dataUrl) مطلوبة."
    override val errorMediaStoreFailed = "فشل تخزين الملف. يرجى المحاولة مرة أخرى."
    override val errorAmountMustBePositive = "يجب أن يكون المبلغ أكبر من صفر."
    override val errorAmountExceedsBalance = "المبلغ المطلوب يتجاوز الرصيد المتاح."
    override val errorPayoutEmailRequired = "البريد الإلكتروني مطلوب لمدفوعات eTransfer."
    override val errorPayoutWiseInfoRequired = "الاسم الكامل ورقم التوجيه ورقم الحساب مطلوبة لمدفوعات Wise."
    override val errorPayoutAccountType = "نوع حساب غير مدعوم. استخدم حساب جاري أو توفير."
    override val errorUnsupportedPayoutMethod = "طريقة دفع غير مدعومة."
    override val errorEventNotCancelled = "الحدث غير ملغى."
    override val errorChatWithSelf = "لا يمكنك بدء دردشة مع نفسك."
    override val errorChatMessageEmpty = "لا يمكن أن تكون الرسالة فارغة."
    override val errorEventOrganizerRequired = "معرف الحدث والمنظم مطلوبان."
    override val errorEventUnavailable = "الحدث لم يعد متاحاً."
    override val errorEventFinished = "الحدث انتهى بالفعل."
    override val errorOrganizerNotProvider = "المنظم ليس مزود خدمة."
    override val errorServiceProviderInactive = "مزود الخدمة غير نشط."
    override val errorSlotsNotFound = "لم يتم العثور على بعض المواعيد."
    override val errorSlotsMustSameEvent = "يجب أن تنتمي جميع المواعيد لنفس الحدث."
    override val errorSlotsMustSameOrganizer = "يجب أن تنتمي جميع المواعيد لمنظم الحدث."
    override val errorSlotsUnavailable = "موعد واحد أو أكثر غير متاح."
    override val errorSlotsInPast = "لا يمكن حجز مواعيد في الماضي."
    override val errorSlotsMustBeConsecutive = "يجب أن تكون المواعيد متتالية."
    override val errorEventIdRequired = "معرف الحدث مطلوب."
    override val errorQuantityAtLeastOne = "الكمية يجب أن تكون 1 على الأقل."
    override val errorPaidReservationRequired = "هذا الحدث يتطلب حجزاً مدفوعاً."
    override val errorEventOrganizerInvalid = "منظم الحدث غير صالح."
    override val errorEventOrganizerMissing = "لم يتم تعيين منظم الحدث."
    override val errorOrganizerCannotAccept = "المنظم غير قادر على قبول الحجوزات."
    override val errorOccurrenceRequired = "تاريخ الحدث مطلوب."
    override val errorOccurrencePassed = "الموعد المحدد قد مضى."
    override val errorTicketsNotEnough = "لا توجد تذاكر كافية متاحة لهذا الحدث."
    override val errorBookingOtherUser = "الحجز ينتمي لمستخدم آخر."
    override val errorBookingNotAwaitingPayment = "الحجز ليس في انتظار الدفع."
    override val errorBookingCancelled = "الحجز ملغى بالفعل."
    override val errorBookingNotActive = "الحجز لم يعد نشطاً."
    override val errorBookingIssuedTickets = "الحجز لديه تذاكر صادرة بالفعل."
    override val errorEventRequiresPaymentFlow = "هذا الحدث يتطلب الدفع. أكمل الدفع لإتمام الحجز."
    override val errorReservationQuantityExceeded = "الكمية المطلوبة تتجاوز الحجز."
    override val errorTicketAlreadyValidated = "التذكرة تم التحقق منها بالفعل."
    override val errorTicketInactive = "التذكرة غير نشطة."
    override val errorTicketAlreadyCancelled = "التذكرة ملغاة بالفعل."
    override val errorTicketUsed = "لا يمكن إلغاء التذاكر المستخدمة."
    override val errorOccurrencesRequired = "المواعيد مطلوبة."
    override val errorRequestRequired = "بيانات الطلب مطلوبة."
    override val errorBookingEventMismatch = "الحجز لا ينتمي للحدث المقدم."
    override val errorBookingProcessed = "الحجز تمت معالجته بالفعل."
    override val errorOverrideAmountAdminOnly = "تعديل المبلغ مسموح للمسؤولين فقط."
    override val errorOverrideAmountPositive = "المبلغ المعدل يجب أن يكون موجباً."
    override val errorUnableDetermineTicketPrice = "تعذر تحديد سعر التذكرة."
    override val errorEmailAlreadyRegistered = "البريد الإلكتروني مسجل بالفعل."
    override val errorInvalidCredentials = "بريد إلكتروني أو كلمة مرور غير صالحة."
    override val errorAccountInactive = "الحساب غير نشط."
    override val errorInvalidRefreshToken = "رمز تحديث غير صالح."
    override val errorAvatarDataUrlRequired = "يجب تقديم بيانات الصورة الرمزية كـ data URL."
    override val errorAvatarMustBeImage = "الصورة الرمزية يجب أن تكون صورة."
    override val errorAvatarInvalidDataUrl = "data URL للصورة الرمزية غير صالح."
    override val errorStripeSignatureInvalid = "توقيع Stripe غير صالح."
    override val errorMediaUnsupportedFormat = "صيغة صورة غير مدعومة."
    override val errorReservationExpired = "انتهت صلاحية الحجز. يرجى البدء بحجز جديد."
    override val login = "تسجيل الدخول"
    override val register = "التسجيل"
    override val continueWithGoogle = "المتابعة مع Google"
    override val continueWithApple = "المتابعة مع Apple"
    override val logout = "تسجيل الخروج"
    override val password = "كلمة المرور"
    override val username = "اسم المستخدم"
    override val firstName = "الاسم الأول"
    override val lastName = "اسم العائلة"
    override val confirmPassword = "تأكيد كلمة المرور"
    override val alreadyHaveAccount = "لديك حساب بالفعل؟"
    override val dontHaveAccount = "ليس لديك حساب؟"
    override val loginHere = "سجل الدخول هنا"
    override val registerHere = "سجل هنا"
    override val welcomeBack = "!مرحباً بعودتك"
    override val createAccount = "إنشاء حساب"
    override val loginError = "فشل تسجيل الدخول. يرجى التحقق من بيانات الاعتماد."
    override val registerError = "فشل التسجيل. يرجى المحاولة مرة أخرى."
    override val passwordsDontMatch = "كلمات المرور غير متطابقة"
    override val fillAllFields = "يرجى ملء جميع الحقول المطلوبة"
    override val invalidEmail = "يرجى إدخال عنوان بريد إلكتروني صالح"
    override val forgotPassword = "نسيت كلمة المرور؟"
    override val passwordResetTitle = "إعادة تعيين كلمة المرور"
    override val passwordResetDescription = "أدخل بريدك الإلكتروني لتلقي تعليمات إعادة التعيين."
    override val passwordResetSetNewPassword = "تعيين كلمة مرور جديدة"
    override val sendResetLink = "إرسال رابط إعادة التعيين"
    override fun passwordResetEmailSent(email: String) = "إذا كان هناك حساب لـ $email، فقد أرسلنا رابط إعادة التعيين."
    override val passwordResetTokenLabel = "رمز إعادة التعيين"
    override val passwordResetTokenDescription = "الصق الرمز من بريدك الإلكتروني أو افتح الرابط على هذا الجهاز."
    override val newPassword = "كلمة المرور الجديدة"
    override val resetPasswordAction = "تحديث كلمة المرور"
    override val passwordResetSuccess = "تم تحديث كلمة المرور! يمكنك تسجيل الدخول بكلمة المرور الجديدة."
    override val profileDeletedMessage = "تم حذف الحساب"
    override val deleteAccountTitle = "حذف الحساب"
    override val deleteAccountDescription = "سيتم تعطيل حسابك، وإخفاء هوية البيانات الشخصية، وإزالة فعالياتك من نتائج البحث."
    override val deleteAccountAction = "حذف الحساب"
    override val deleteAccountConfirmMessage = "هل أنت متأكد؟ يرجى سحب أي رصيد متبقٍ عبر طلب الدفع قبل حذف الحساب."
    override val aiConsentSectionTitle = "معالجة بيانات الذكاء الاصطناعي"
    override val aiConsentEnabled = "لقد وافقت على مشاركة البيانات مع خدمات الذكاء الاصطناعي (OpenAI، Google) لميزات اختيارية مثل التفريغ النصي وإنشاء الأوصاف."
    override val aiConsentDisabled = "الموافقة على معالجة بيانات الذكاء الاصطناعي غير مفعّلة. ميزات الذكاء الاصطناعي غير متاحة."
    override val aiConsentWithdrawButton = "سحب الموافقة"
    override val aiConsentEnableButton = "تفعيل ميزات الذكاء الاصطناعي"
    override val aiConsentWithdrawConfirmTitle = "سحب موافقة الذكاء الاصطناعي؟"
    override val aiConsentWithdrawConfirmMessage = "ستصبح ميزات الذكاء الاصطناعي (التفريغ النصي، إنشاء الأوصاف، صفحات الهبوط) غير متاحة. يمكنك تفعيلها مرة أخرى في أي وقت."
    override val aiConsentWithdrawnSuccess = "تم سحب الموافقة على معالجة بيانات الذكاء الاصطناعي"
    override val aiConsentEnabledSuccess = "تم منح الموافقة على معالجة بيانات الذكاء الاصطناعي"
    override val errorAccountDeleted = "تم حذف الحساب."
    override val errorAccountBalanceNotZero = "يرجى سحب الرصيد المتبقي قبل حذف حسابك."
    override val backToLogin = "العودة لتسجيل الدخول"
    override val invalidPhone = "يرجى إدخال رقم هاتف صالح"
    override val provideAnyContact = "أدخل الهاتف أو البريد الإلكتروني"
    override val checkContacts = "يرجى التحقق من صيغة جهات الاتصال"
    override val contactSubmitting = "جارٍ الحفظ..."
    override val contactSubmitted = "تم إرسال الطلب"
    override val book = "حجز"
    override val bookFree = "حجز مجاني"
    override val bookingSuccess = "!تم الحجز بنجاح"
    override val bookingFailed = "فشل الحجز"
    override fun bookForPrice(price: String) = "حجز بـ $price"
    override val prev = "السابق"
    override val showAll = "عرض الكل"
    override val collapse = "طي"
    override val missingTitle = "أدخل عنوان الحدث"
    override val missingDescription = "أدخل وصف الحدث"
    override val missingScheduleType = "اختر نوع الجدول"
    override val missingDate = "اختر تاريخ الحدث"
    override val missingTime = "اختر وقت الحدث"
    override val missingWeeklyDays = "اختر يوماً واحداً أو أكثر"
    override val missingWeeklyTime = "اختر الوقت للحدث الأسبوعي"
    override val missingSlotDays = "اختر أيام المواعيد"
    override val missingSlotStart = "اختر وقت بدء الموعد"
    override val missingSlotEnd = "اختر وقت انتهاء الموعد"
    override val missingLocation = "يرجى تحديد موقع الحدث"
    override val optional = "اختياري"
    override val bookingsTitle = "الحجوزات"
    override val unconfirmedRequestsTitle = "طلبات غير مؤكدة"
    override val detailsButton = "التفاصيل"
    override val hideDetailsBooking = "إخفاء"
    override val noBookings = "لا توجد حجوزات بعد"
    override val noUnconfirmedRequests = "لا توجد طلبات غير مؤكدة"
    override val ticketInfoLabel = "التذكرة"
    override val contactInfoLabel = "معلومات الاتصال"
    override val paymentInfoLabel = "الدفع"
    override val loadingPayment = "جارٍ التحميل..."
    override val clientLabel = "العميل"
    override val paymentAmount = "المبلغ"
    override val paymentStatus = "الحالة"
    override val paymentDate = "التاريخ"
    override val appStoreBannerTitle = "احصل على التطبيق"
    override val appStoreBannerMessage = "حمّل تطبيقنا للحصول على أفضل تجربة"
    override val downloadOnAppStore = "تحميل من App Store"
    override val getItOnGooglePlay = "متوفر على Google Play"
    override val downloadAppLinks = "حمّل تطبيقنا"
    override val updateAvailable = "تحديث متاح"
    override val updateRequired = "التحديث مطلوب"
    override val updateAvailableMessage = "يتوفر إصدار جديد من iJoin. حدّث الآن للحصول على أحدث الميزات والتحسينات."
    override val updateRequiredMessage = "يرجى تحديث iJoin لمواصلة استخدام التطبيق. هذا الإصدار لم يعد مدعوماً."
    override val updateNow = "تحديث الآن"
    override val updateLater = "لاحقاً"
    override val newVersion = "الإصدار الجديد"
    override val currentVersion = "الإصدار الحالي"
    override val whatsNew = "ما الجديد"
    override val landingModeClassic = "كلاسيكي"
    override val landingModeAi = "صفحة هبوط AI"
    override val landingModeTitle = "نوع صفحة الهبوط"
    override val landingDescriptionLabel = "وصف الصفحة"
    override val landingDescriptionPlaceholder = "صف حدثك ليقوم AI بإنشاء صفحة هبوط جميلة..."
    override val recordVoice = "تسجيل الصوت"
    override val stopRecording = "إيقاف التسجيل"
    override val transcribing = "جارٍ النسخ..."
    override val recordingTooShort = "التسجيل قصير جداً (الحد الأدنى 3 ثوانٍ)"
    override val recordingTooLong = "التسجيل طويل جداً (الحد الأقصى 5 دقائق)"
    override val microphoneAccessDenied = "تم رفض الوصول للميكروفون"
    override fun recordingDuration(seconds: Int) = "${seconds}ث"
    override val enableLandingPageLabel = "استخدام صفحة الهبوط"
    override val enableLandingPageDescription = ""
    override val termsOfService = "شروط الخدمة"
    override val privacyPolicy = "سياسة الخصوصية"
    override val refundPolicy = "سياسة الاسترداد والإلغاء"
    override val organizerTerms = "شروط المنظمين"
    override val aiDataConsent = "الموافقة على معالجة البيانات بالذكاء الاصطناعي"
    override val aiConsentTitle = "ميزات الذكاء الاصطناعي تستخدم خدمات طرف ثالث"
    override val aiConsentDescription = "تستخدم بعض ميزات هذا التطبيق خدمات الذكاء الاصطناعي المقدمة من OpenAI وGoogle. عند استخدام هذه الميزات، يتم إرسال بعض المحتوى الذي تقدمه إلى هذه الخدمات للمعالجة."
    override val aiConsentDataSent = ":البيانات التي قد يتم إرسالها"
    override val aiConsentDataSentAudio = "التسجيلات الصوتية (للتحويل إلى نص)"
    override val aiConsentDataSentDescription = "أوصاف الفعاليات (لتحسين النص)"
    override val aiConsentDataSentLanding = "تفاصيل صفحة الهبوط (لإنشاء المحتوى)"
    override val aiConsentProviders = "تتم معالجة البيانات بواسطة OpenAI (OpenAI, L.L.C.) وGoogle (Google LLC). لا يتم إرسال بياناتك الشخصية (الاسم، البريد الإلكتروني) إلا إذا كانت جزءًا من المحتوى المقدم. راجع المستند الكامل للتفاصيل."
    override val aiConsentOptional = "ميزات الذكاء الاصطناعي اختيارية. يمكنك استخدام التطبيق بدونها."
    override val aiConsentAccept = "أوافق"
    override val aiConsentDecline = "ليس الآن"
    override val iAgreeToThe = ":أوافق على ما يلي"
    override val iAgreeToTerms = "أوافق على شروط الخدمة وسياسة الخصوصية وسياسة الاسترداد"
    override val iAgreeToOrganizerTerms = "أوافق على شروط المنظمين"
    override val pleaseAcceptTerms = "يرجى قبول الشروط للمتابعة"
    override val pleaseAcceptOrganizerTerms = "يرجى قبول شروط المنظمين لنشر الأحداث"
    override val viewDocument = "عرض"
    override val legalDocumentLoading = "جارٍ تحميل المستند..."
    override val legalDocumentLoadError = "فشل تحميل المستند"
    override val newUserGoogleNote = ":إذا كنت جديداً، يرجى قبول الشروط قبل تسجيل الدخول بـ Google"
    override val legalDocumentsUpdated = "تم تحديث الشروط"
    override val legalDocumentsUpdatedDescription = "قمنا بتحديث شروطنا. يرجى مراجعة وقبول المستندات المحدثة لمواصلة استخدام التطبيق."
    override val iAcceptUpdatedTerms = "أقبل الشروط المحدثة"
    override val continueButton = "متابعة"
    override val deleteEventFailed = "تعذر حذف الحدث."
    override val mediaDesktopLabel = "لأجهزة سطح المكتب (عريض)"
    override val mediaMobileLabel = "للجوال (مربع)"
    override val slotLoadFailed = "تعذر تحميل الفترات"
    override val slotBookingFailed = "تعذر حجز الفترات"
    override val ticketIssuanceFailed = "تعذر إصدار التذاكر"
    override val unpublishedBookingNotice = "ستتوفر الحجوزات بمجرد نشر هذا الحدث."
    override val paymentStripeOverlayTitle = "الدفع عبر Stripe"
    override val paymentStripeOverlayDescription = "أدخل بيانات بطاقتك لإكمال الحجز."
    override val paymentStripeOverlayPayButton = "ادفع الآن"
    override val paymentStripeOverlayPayButtonLoading = "جارٍ المعالجة..."
    override val paymentStripeOverlayCancelButton = "إلغاء"
    override val paymentStripeOverlayOpenError = "تعذر فتح صفحة دفع Stripe."
    override val paymentStripeOverlayCancelMessage = "تم إلغاء الدفع"
    override val paymentStripeOverlayInitError = "تعذر تهيئة Stripe."
    override val paymentStripeOverlayPaymentFailed = "فشل الدفع"
    override val paymentStripeOverlayUnexpectedStatusPrefix = "حالة غير متوقعة: "
    override val paymentStripeOverlayProcessingFailed = "فشل في معالجة الدفع"
    override val appStoreUnavailableMessage = "عذرًا، يتم نشر التطبيق في المتجر وسيكون متاحًا قريبًا."


}
